import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/Button/button';
import { Link } from '@/i18n/routing';
import { getEmailProviderRedirectUrl } from '@/libs/auth/emailProviderRedirect';

interface ResetPasswordSuccessPopupProps {
  email: string;
}

const ResetPasswordSuccessPopup = ({ email }: ResetPasswordSuccessPopupProps) => {
  const t = useTranslations('sign-in');

  return (
    <div className="flex flex-col h-full mt-2.5">
      <div className=" flex mb-[0.1875rem] w-full">
        <p className="text-white paragraph-m-medium">
          {t('we-v-sent-you-a-letter-to-your-email')}
        </p>
      </div>

      <div className="flex flex-col gap-4 flex-grow overflow-auto mt-3.5">
        <div className="flex items-start gap-2.5 bg-main-900 rounded-lg p-3">
          <p className="paragraph-s-medium flex items-center justify-center min-w-6 min-h-6 bg-main-800 rounded-md text-white">1</p>
          <div className="flex flex-col ">
            <p className="paragraph-s-medium text-white mb-3">{t('open-your-mailbox')}</p>
            <p className="paragraph-s-medium text-white/80 whitespace-pre-line">
              {t.rich('redeem-card-instruction-text', { email: email || '' })}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-2.5 bg-main-900 rounded-lg p-3">
          <p className="paragraph-s-medium flex items-center justify-center min-w-6 min-h-6 bg-main-800 rounded-md text-white">2</p>
          <div className="flex flex-col ">
            <p className="paragraph-s-medium text-white mb-3 mt-[0.1875rem]">{t('follow-the-instructions')}</p>
            <p className="paragraph-s-medium text-white/80 whitespace-pre-line">
              <span className="text-white/80 paragraph-s-medium">{t('create-a-new-password-and-confirm-it')}</span>
            </p>
          </div>
        </div>
        <div className="flex items-start gap-2.5 bg-main-900 rounded-lg p-3">
          <p className="paragraph-s-medium flex items-center justify-center min-w-6 min-h-6 bg-main-800 rounded-md text-white">3</p>
          <div className="flex flex-col ">
            <p className="paragraph-s-medium text-white mb-3 mt-[0.1875rem]">{t('sign-in')}</p>
            <p className="paragraph-s-medium text-white/80">
              {t('sign-in-using-your-new-password')}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-4 max-md:mb-0.5">
        <Button
          type="button"
          variant="primary"
          className="w-full py-3"
          asChild
        >
          <Link href={getEmailProviderRedirectUrl(email) ?? ''}>
            {t('go-to-mail')}
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default ResetPasswordSuccessPopup;
